import React from "react";
import { Link } from "react-router-dom";
import { Cloud, Twitter, Linkedin, Github, Mail, Phone, MapPin, Building2 } from "lucide-react";

const footerLinks = {
  Hosting: [
    { label: "VPS Hosting", href: "/vps-hosting" },
    { label: "Cloud Hosting", href: "/cloud-hosting" },
    { label: "Shared Hosting", href: "/shared-hosting" },
    { label: "GPU Cloud", href: "/gpu-cloud" },
  ],
  Services: [
    { label: "Domain Names", href: "/domains" },
    { label: "SSL Certificates", href: "/ssl" },
    { label: "Email Hosting", href: "/email-hosting" },
    { label: "AI Plan Picker", href: "/plan-recommender" },
  ],
  Company: [
    { label: "Blog", href: "/blog" },
    { label: "Refer & Earn", href: "/refer" },
    { label: "Contact Us", href: "/contact" },
    { label: "Admin Panel", href: "/admin" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="footer" style={{ background: "#030305", borderTop: "1px solid rgba(0,243,255,0.08)" }}>
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, #00F3FF, #BC13FE)", boxShadow: "0 0 15px rgba(0,243,255,0.3)" }}>
                <Cloud size={18} color="#030305" strokeWidth={2.5} />
              </div>
              <span className="font-orbitron font-700 text-sm tracking-wider text-gradient">INDIACLOUD.AI</span>
            </div>
            <p className="font-outfit text-sm text-gray-500 leading-relaxed mb-3" style={{ fontWeight: 300 }}>
              India's most powerful AI cloud hosting platform.
              Built for modern Indian businesses with global ambitions.
            </p>
            <p className="font-outfit text-xs text-gray-600 mb-5" style={{ fontWeight: 300 }}>
              A product of <span className="text-gray-400 font-500">MIEUX TECHNOLOGIES PVT LTD</span>
            </p>
            <div className="flex items-center gap-3">
              {[Twitter, Linkedin, Github, Mail].map((Icon, i) => (
                <button
                  key={i}
                  className="w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-110"
                  style={{ background: "rgba(0,243,255,0.08)", border: "1px solid rgba(0,243,255,0.15)" }}
                >
                  <Icon size={15} color="#00F3FF" />
                </button>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 className="font-rajdhani font-700 text-sm text-white tracking-wider mb-4 uppercase">{section}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="font-outfit text-sm text-gray-500 hover:text-white transition-colors no-underline"
                      style={{ fontWeight: 300 }}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact info */}
        <div className="flex flex-wrap gap-6 mb-8 pb-8"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
          {[
            { icon: Mail, text: "support@indiacloud.ai" },
            { icon: Phone, text: "+011 41103555 / +91 9873385555" },
            { icon: MapPin, text: "B-19, Mohan Estate, New Delhi-110044" },
            { icon: Building2, text: "MIEUX TECHNOLOGIES PVT LTD" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-sm text-gray-600 font-outfit">
              <item.icon size={13} color="#00F3FF" />
              {item.text}
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-outfit text-xs text-gray-700">
            &copy; {new Date().getFullYear()} IndiaCloud.ai &mdash; MIEUX TECHNOLOGIES PVT LTD. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-gray-700 font-outfit">
            <span className="cursor-pointer hover:text-gray-400 transition-colors">Privacy Policy</span>
            <span className="cursor-pointer hover:text-gray-400 transition-colors">Terms of Service</span>
            <span className="cursor-pointer hover:text-gray-400 transition-colors">Refund Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
